import { PATTERN_ROAD_ID } from 'game/defs/PatternRoad';

export const RoadSprite = (
  <rect width={10440} height={549} fill={`url(#${PATTERN_ROAD_ID})`} />
);
